import {extendConfig} from './extend-config';

export const config = extendConfig({
  datadog: {
    environment: `preview`,
    enabled: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
  },
});
